import React from 'react';
import { ResponsiveImage } from '../ResponsiveImage';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Header from '../Header';
import Footer from '../Footer';
import { ArticleCard } from './ArticleCard';
import { ArticleCta } from './ArticleCta';
import { useArticleMetadata } from '../../hooks/useArticleMetadata';

export const ArticleListing = ({ articles, section }) => {
  const featured = articles[0];
  const title = section === 'carriere' ? 'Conseils carrière' : 'Conseils en recrutement';
  const description = section === 'carriere' ? 'Ressources et conseils pour booster votre parcours professionnel' : 'Expertise et bonnes pratiques pour optimiser vos recrutements';
  useArticleMetadata({ title, description, path: `/conseils-${section}` });
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main id="main-content" tabIndex={-1}>
        <section className="bg-[#E30022] text-white py-12 sm:py-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 data-testid="article-list-title" className="text-4xl sm:text-5xl lg:text-6xl font-serif mb-4 break-words">{title}</h1>
            <p data-testid="article-list-description" className="text-base sm:text-lg">{description}</p>
          </div>
        </section>
        <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
            <div className="aspect-video overflow-hidden rounded-lg">
              <ResponsiveImage src={featured.image} sizes="(min-width: 1280px) 576px, (min-width: 1024px) 50vw, 100vw" alt={featured.title} data-testid="featured-article-image" className="w-full h-full object-contain" loading="eager" />
            </div>
            <div className="min-w-0">
              <span data-testid="featured-article-category" className="text-[#E30022] font-medium">{featured.category}</span>
              <h2 data-testid="featured-article-title" className="text-base md:text-lg font-serif text-gray-800 mt-3 mb-4">{featured.title}</h2>
              <p data-testid="featured-article-excerpt" className="text-gray-600 text-sm sm:text-base mb-6 leading-relaxed">{featured.excerpt}</p>
              <Link to={`/conseils-${section}/${featured.slug}`} data-testid="featured-article-link" className="inline-flex items-center gap-2 text-[#E30022] font-medium hover:underline group">
                Lire l’article <ArrowRight aria-hidden="true" className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </Link>
            </div>
          </div>
        </section>
        <section data-testid="article-list-grid" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-16">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {articles.slice(1).map(article => <ArticleCard key={article.slug} article={article} section={section} />)}
          </div>
        </section>
        <ArticleCta section={section} />
      </main>
      <Footer />
    </div>
  );
};